import { useMutation, useQueryClient } from "react-query";
import { createExpense } from "../../../services/expenses";
import { updateExpenseCategory } from "../../../services/expenses";

export const useCreateExpenseMutation = () => {
  const queryClient = useQueryClient();
  return useMutation((data) => createExpense(data), {
    onSuccess: () => {
      queryClient.invalidateQueries(["getExpenses"]);
    },
  });
};

// Custom hook to update an expense's category
export const useUpdateExpenseCategory = () => {
  return useMutation((data) => updateExpenseCategory(data));
};
